import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { FormContext } from '../Component/Forms/FormContext';
import Element from './Element';
import ThemeControls from '../Component/AllThemesControl';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext';
import { PreviewSharp } from '@mui/icons-material';

const generateUniqueId = () => {
    return Math.random().toString(36).substring(1);
};

function RateSheetAddRow(props) {
    const { useStyle } = ThemeControls;
    const classes = useStyle();
    const { id, field_context, field_id, field_value, field_disabled_Edit, field_temp_value, field_option_src } = props;
    const { handleChange: handleChangeParent } = useContext(FormContext);
    // const { contextJson } = useContext(FormJSONCreateContext);
    const formJSON = field_context;
    const [tableRows, setTableRows] = useState([]);
    const [elements, setElements] = useState(formJSON);

    const forceUpdate = useCallback((args) => setElements(args), []);
    const { fields } = elements;

    useEffect(() => {
        if (Array.isArray(field_value)&&field_value&&field_value.length>0 && id){
            setTableRows(field_value);
            console.log(field_value)
            const tempData = [...field_value];
            tempData?.forEach(fields => {
                fields?.map((thisField)=>{
                  if (thisField.field_runtime_ops) {
                    thisField.field_runtime_ops.forEach(field => {
                      if (field.condition)
                        var resultEval;
                        var stmt = "resultEval = thisField." + field.condition.field + " " + field.condition.operator + " \"" + field.condition.checkVal + "\""
                        eval(stmt);
                        console.log(resultEval);
                        if (resultEval) {
                            // console.log(eval(field));
                            eval(field.ops);
                            setTableRows(tempData);
                        }
                    });
                  }
                })
              })
              
        }
    }, [field_value]);

    const newRows = tableRows.concat([
        fields.map((field) => ({
            ...field,
            field_id: field.field_id + generateUniqueId(),
            field_value: (field.field_type === "hidden" ? field.field_value : ""),
            field_label: "",
            // field_option_src: {
            //     ...field.field_option_src,
            //     field_option_src_critieria: (field.field_option_src && field.field_id === "techprefix" && field_option_src[keyProp] !== undefined) ? field_option_src[keyProp] : (field.field_option_src ? field.field_option_src.field_option_src_critieria : undefined)
            // }
        }))
    ]);

    // useEffect(()=>{
    //     if(!id){
    //         setTableRows(newRows);
    //         // handleChangeDataMarge(newRows, keyProp)
    //     }
    // },[])

    const removeRow = (index) => {
        setTableRows((prevRows) => prevRows.filter((_, i) => i !== index));
    };

    useEffect(() => {
        console.log("field_temp_value changed:", field_temp_value);
        const Count = field_temp_value['sheetnumber']?.split(', ')
    
        const sheetCount = Count?.length;
        const newRows = Array.from({ length: sheetCount }, () =>
            fields.map((field) => ({
                ...field,
                field_id: field.field_id + generateUniqueId(),
                field_value: field.field_type === "hidden" ? field.field_value : "",
                field_label: "",
                 field_option_src: {
                            ...field.field_option_src,
                            field_option_src_critieria: (field.field_option_src && field.field_id === "multipleTechPrefixData" && field_temp_value['vendorid'] !== undefined) ? field_temp_value['vendorid'] : (field.field_option_src ? field.field_option_src.field_option_src_critieria : undefined)
                        }
            }))
        );
        // console.log(newRows.flat())
        setTableRows([...newRows]);
 
    }, [field_temp_value, field_option_src]);

    const handleChange = (_id, event, valueStr) => {
        // console.log(valueStr)
        const updatedRows = [...tableRows];
        updatedRows.forEach((row) => {
            row.forEach((field) => {
                if (field.field_id === _id) {
                    field.field_value = valueStr;
                }
            });
        });
    
        setTableRows(updatedRows);
        const arrayOfObjects = updatedRows?.map(innerArray => {
            const resultObject = {};
            innerArray.forEach(field => {
                const { field_id, field_value} = field;
                const fieldId = field_id.split(".")[0];
                resultObject[fieldId] = field_value;
            }) 
            return resultObject;
        })
        console.log(arrayOfObjects)
        handleChangeParent(field_id,{},arrayOfObjects.flat())
    };


    return (
        <>
            <FormContext.Provider value={{ handleChange }}>
                <div className={classes.breakForm}>
                    <div className={classes.subtable}>
                        <div className={classes.btnHeader}>
                            <h1>{formJSON.page_heading_label ? formJSON.page_heading_label : ''}</h1>
                            <></>
                        </div>
                        <div style={{ overflow: 'auto' }}>
                            <table>
                                <thead>
                                    <tr>
                                        {formJSON.fields.map((field) => (
                                            field.field_type !== "hidden" && <th key={field.field_id}>{String(field.field_label)}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableRows.map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {row.map((field, fieldIndex) => (
                                                field.field_type !== "hidden" && <td key={field.field_id}>
                                                    <Element key={rowIndex} field={field} />
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </FormContext.Provider>
        </>
    );
}
export default RateSheetAddRow;
// function RateSheetAddRow(props) {
//     const { useStyle } = ThemeControls;
//     const classes = useStyle();
//     const { id, field_context, field_id, field_value, field_disabled_Edit, field_temp_value, field_option_src } = props;
//     const { handleChange: handleChangeParent } = useContext(FormContext);
//     const contextJson = field_context;
//     const [mergedData, setMergedData] = useState({});
//     const [allData,setAlldata] = useState(field_value || []);
//     const [values, setValues] = useState({ Parameter: [], Parameter_1: [] });
//     let data={}
//     useEffect(()=>{
//         if(field_value){
//             Object.keys(contextJson).map((key, index) => {
//                 const filteredData = filterFieldValue(key, field_value);
//                 console.log(filteredData)
//                 setValues(prevValues => ({
//                   ...prevValues,
//                   [key]: filteredData,
//                 }));
//             })
//         }
//     },[])

//     const handleChangeDataMerge = useCallback((updatedRows, keyProp) => {
//         console.log(updatedRows)
//         setValues((prevValues) => ({
//             ...prevValues,
//             [keyProp]: updatedRows,
//           }));
//     },[]);
    
//     console.log(field_value)
//     console.log(values)
//       const filterFieldValue = (key, field_value) => {
//         if (key === 'Parameter' && id) {
//           const GtsToCarrier = field_value?.filter(obj => obj.trafficstatus === 1);
//           const tempData = generateTempData(GtsToCarrier, contextJson[key], field_disabled_Edit);
//           return tempData;
//         } else if(key === 'Parameter_1' && id){
//           const CarrierToGts = field_value?.filter(obj => obj.trafficstatus === 2);
//           const tempData = generateTempData(CarrierToGts, contextJson[key], field_disabled_Edit);
//           return tempData;
//         }else{
//             return []
//         }
//       };

//       const generateTempData = (field_value, formJSON, field_disabled_Edit) => {
//         if (Array.isArray(field_value) && field_value.length > 0) {
//           const tempData = field_value.map((row) => {
//             const uqId = generateUniqueId();
//             let temp_value = [];
//             const updateRow = formJSON.fields.map((field) => {
//               let fieldValue = row[field.field_id];
//               if (field.field_id === "techprefix" && row["techprefix"] === "-1" && row["trafficstatus"] === 1 && row['gtsDealtechprefix']) {
//                 let temp = row['gtsDealtechprefix'].map(item => item.techprefix);
//                 temp_value = row['gtsDealtechprefix'];
//                 fieldValue = temp.join(', ');
//               }
//               if (field.field_id === "breakoutname" && row['gtsDealbreakout']) {
//                 let temp = row['gtsDealbreakout'].map(item => item.breakout);
//                 temp_value = row['gtsDealbreakout'];
//                 fieldValue = temp.join(', ');
//               }
//               return {
//                 ...field,
//                 field_id: field.field_id + uqId,
//                 field_value: fieldValue,
//                 field_temp_bucket: temp_value,
//                 field_label: "",
//                 field_disabled: field_disabled_Edit === 3 ? true : field.field_disabled
//               };
//             });
//             return updateRow;
//           });
      
//           return tempData;
//         } else {
//           return [];
//         }
//       };
       
//       useEffect(() => {
//         if(values.Parameter.length>0 || values.Parameter_1.length>0){
//             let mergedArrays = [];
//         for (const key in values) {
//             if (values.hasOwnProperty(key)) {
//                 mergedArrays = [...mergedArrays, ...values[key]];
//             }
//         }
//             handleChangeParent(field_id, {}, mergedArrays);
//         }
//       }, [values]);

//     const handleTotal = (rowData, key) => {
//         let sum = 0;
//         if (rowData&&rowData.length>0 ) {
//           rowData.forEach((item, rowIndex) => {
//                 sum += parseFloat(item[key]) || 0;
//               })
//         }
//         return sum.toFixed(2);
//       };

//     const renderNested = Object.keys(contextJson).map((key, index) => {
//         if (key !== "xioFEConfig") {
//             return (
//                 <NestedRender
//                     key={index}
//                     id={id}
//                     setDataObj={setMergedData}
//                     formJSON={contextJson[key]}
//                     keyProp={key}
//                     field_value={values[key]}
//                     handleChangeDataMarge={handleChangeDataMerge}
//                     field_disabled_Edit={field_disabled_Edit}
//                     field_temp_value={field_temp_value}
//                     field_option_src={field_option_src}
//                 />
//             );
//         }
//         return null;
//     });

//     const additionalElements = (
//         <div className={classes.breakForm}>
//             <div className={classes.subtable}>
//             <div style={{ overflow: 'auto' }}>
//                 <table className='mb'>
//                     <thead>
//                         <tr>
//                             {contextJson['Parameter'].fields.map((field, colIndex) => (
//                                 field.field_type !== "hidden" && 
//                                 <th key={colIndex}>
//                                     {field.field_label}
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         <tr className='noBorder'>
//                             {contextJson['Parameter'].fields.map((field, colIndex) => (
//                                 field.field_type !== "hidden" && 
//                                 <td key={colIndex}>
//                                     {field.field_Sum === "yes" && handleTotal(allData, field.field_id)}
//                                 </td>
//                             ))}
//                         </tr>
//                     </tbody>
//                 </table>
//             </div>
//             </div>
//         </div>
//     );
    

//     return (
//         <>
//         {renderNested}
//         {additionalElements}
//         </>
//     );
// }

